import _set from "lodash/set";
import _get from "lodash/get";
import _isArray from "lodash/isArray";
import _isFunction from "lodash/isFunction";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, cloneElement, isValidElement } from 'react';
import { unset } from '../utils';
import { useIsMounted } from '../hooks';
import { areEqual, getFormInputs, requiredFieldValidation } from './utils';

var childArr = function childArr(childs) {
  return _isArray(childs) ? childs : [childs];
};

export var useForm = function useForm(_ref) {
  var _ref$values = _ref.values,
      initValues = _ref$values === void 0 ? {} : _ref$values,
      initChildren = _ref.children,
      onSubmit = _ref.onSubmit,
      onChange = _ref.onChange,
      onReset = _ref.onReset,
      disabled = _ref.disabled;
  // Every input has it's own state but all values that are typed by the user need to be saved into state attached into the form
  var children = childArr(initChildren);

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isTouched = _useState6[0],
      setIsTouched = _useState6[1];

  var isMounted = useIsMounted();

  var mergedValues = _objectSpread(_objectSpread({}, initValues), values);

  var formOptions = {
    onSubmit: function onSubmit() {
      return handleSubmit();
    },
    resetForm: function resetForm() {
      return _resetForm();
    },
    values: values,
    setValues: setValues,
    loading: loading,
    setLoading: setLoading,
    isTouched: isTouched,
    setIsTouched: setIsTouched
  }; // All form values are stored to inputs ref, every input field has a state

  var handleValuesChange = function handleValuesChange(val, formId) {
    var initValue = _get(initValues, formId);

    var allFormInputs = getFormInputs(children);
    var correspondChild = allFormInputs.find(function (e) {
      var _e$props;

      return (e === null || e === void 0 ? void 0 : (_e$props = e.props) === null || _e$props === void 0 ? void 0 : _e$props.formId) === formId;
    });
    setValues(function (prev) {
      var newValues = areEqual(val, initValue, correspondChild) ? unset(prev, formId) : _set(_objectSpread({}, prev), formId, val); // We need this sto because we can have a state change coming from onChange of the form (if change one field will lead to clear of other filed for example). In this case the two setStates are receiving the old state, so we need first to set the state then to call onChange, which can call another setState with already updated values

      setTimeout(function () {
        _isFunction(onChange) && onChange(formId, _objectSpread(_objectSpread({}, formOptions), {}, {
          values: newValues
        }));
      });
      return newValues;
    });
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var submitErrors, error;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              !isTouched && setIsTouched(true);
              submitErrors = [];
              getFormInputs(children.map(cloneChildren)).forEach(function (el) {
                var _el$props, _el$props2;

                var inputValue = mergedValues[el === null || el === void 0 ? void 0 : (_el$props = el.props) === null || _el$props === void 0 ? void 0 : _el$props.formId];
                if (_isFunction(el === null || el === void 0 ? void 0 : (_el$props2 = el.props) === null || _el$props2 === void 0 ? void 0 : _el$props2.validate)) submitErrors.push(el.props.validate(inputValue, mergedValues));
              });

              if (!(submitErrors.filter(Boolean).length || !_isFunction(onSubmit))) {
                _context.next = 6;
                break;
              }

              // eslint-disable-next-line no-console
              (env === 'local' || env === 'development') && console.log(submitErrors);
              return _context.abrupt("return");

            case 6:
              setLoading(true);
              _context.next = 9;
              return onSubmit(mergedValues);

            case 9:
              error = _context.sent;
              isMounted.current && (error ? setLoading(false) : _resetForm());

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var _resetForm = function _resetForm() {
    setValues({});
    setIsTouched(false);
    setLoading(false);
    _isFunction(onReset) && onReset(formOptions);
  };

  var cloneChildren = function cloneChildren(allChilds) {
    var generateChilds = function generateChilds(child, i) {
      var _child$props = child.props,
          props = _child$props === void 0 ? {} : _child$props;
      var children = props.children,
          formId = props.formId;
      var hasId = props && formId;
      var key = formId !== null && formId !== void 0 ? formId : "Child".concat(i);

      var childFormProps = function childFormProps(childProps) {
        var isTouchedProp = isTouched || childProps.isTouched;
        var disabledProp = disabled || childProps.disabled;
        return _objectSpread(_objectSpread(_objectSpread({
          onChange: function onChange(val) {
            return handleValuesChange(val, childProps.formId);
          },
          value: _get(mergedValues, childProps.formId)
        }, (_isFunction(childProps.validate) || (props === null || props === void 0 ? void 0 : props.required)) && {
          validate: function validate(val) {
            return _isFunction(childProps.validate) ? childProps.validate(val, mergedValues) : requiredFieldValidation(val, child);
          }
        }), isTouchedProp && {
          isTouched: isTouchedProp
        }), disabledProp && {
          disabled: disabledProp
        });
      };

      switch (true) {
        case /*#__PURE__*/isValidElement(child):
          return /*#__PURE__*/cloneElement(child, hasId ? _objectSpread({
            key: key
          }, childFormProps(props)) : {
            key: key,
            children: cloneChildren(children)
          });

        case _isFunction(child):
          return cloneChildren(child(formOptions));

        default:
          return child;
      }
    };

    return childArr(allChilds).filter(Boolean).map(generateChilds);
  };

  return {
    handleSubmit: handleSubmit,
    loading: loading,
    reset: _resetForm,
    values: values,
    newChildren: children.map(cloneChildren)
  };
};